// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Caret-module--cls1--2A7qP","cls2":"Caret-module--cls2--1i9Hf Caret-module--cls1--2A7qP","flipped":"Caret-module--flipped--Dyp2p"};